import React from 'react';
import { motion } from 'framer-motion';
import { Users, ShoppingCart } from 'lucide-react';

const StatsSection = ({ stats, loading }) => {
  return (
    <motion.div
      className="stats-section"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
    >
      <div className="stats-grid">
        <motion.div
          className="stat-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <div className="stat-icon">
            <Users size={28} />
          </div>
          <div className="stat-content">
            <h3>Total Customers</h3>
            <div className="stat-number">
              {loading ? (
                <div className="stat-loading">
                  <div className="stat-spinner"></div>
                </div>
              ) : (
                stats.totalCustomers?.toLocaleString() || 0
              )}
            </div>
          </div>
        </motion.div>

        <motion.div
          className="stat-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="stat-icon">
            <ShoppingCart size={28} />
          </div>
          <div className="stat-content">
            <h3>Total Orders</h3>
            <div className="stat-number">
              {loading ? (
                <div className="stat-loading">
                  <div className="stat-spinner"></div>
                </div>
              ) : (
                stats.totalOrders?.toLocaleString() || 0
              )}
            </div>
          </div>
        </motion.div>

        <motion.div
          className="stat-card"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <div className="stat-icon">
            <Users size={28} />
          </div>
          <div className="stat-content">
            <h3>New Customers This Month</h3>
            <div className="stat-number">
              {loading ? (
                <div className="stat-loading">
                  <div className="stat-spinner"></div>
                </div>
              ) : (
                stats.newThisMonth?.toLocaleString() || 0
              )}
            </div>
          </div>
        </motion.div>

      </div>
    </motion.div>
  );
};

export default StatsSection;
